<div class="overlay">
    <div class="center"> 
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>
  </div>